import styled, { useTheme } from 'styled-components'
import { Typo, TypoVariant } from '@/components/common/typography'
import ROUTES from '@/constants/legacy/constRoutes'
import { QueryStringKeyEnum } from '@/constants/query-string-key.enum'
import { useProductDetailEventTracker } from '@/containers/event-tracker/product-detail.event-tracker-new'
import { useCustomRouter, usePetType } from '@/containers/hooks'

interface ProductDetailTagsProps {
  productId: number
  productName: string
  tags: string[]
}

export const ProductDetailTags = ({ productId, productName, tags }: ProductDetailTagsProps) => {
  const { color } = useTheme()
  const { push } = useCustomRouter()
  const { getPetType } = usePetType()
  const { trackClickProductDetailTag } = useProductDetailEventTracker()

  const handleClickTagButton = ({ tag }: { tag: string }) => {
    trackClickProductDetailTag({
      originProductId: productId,
      originProductName: productName,
      tagName: tag,
    })

    push({
      pathname: ROUTES.SEARCH_RESULT,
      query: {
        [QueryStringKeyEnum.SearchQuery]: tag,
        [QueryStringKeyEnum.SearchPetType]: getPetType(),
      },
    })
  }

  return (
    <ProductDetailTagsWrapper className="product-detail-tags">
      <div className="product-detail-tags__title">
        <Typo as="h2" variant={TypoVariant.Heading6Bold} color={color.gray900}>
          관련 태그
        </Typo>
      </div>
      <ul className="product-detail-tags__list">
        {tags.map((tag, index) => (
          <li className="product-detail-tags__item" key={index}>
            <button className="product-detail-tags__tag" type="button" onClick={() => handleClickTagButton({ tag })}>
              <Typo variant={TypoVariant.Body3Medium} color={color.blue400}>
                #{tag}
              </Typo>
            </button>
          </li>
        ))}
      </ul>
    </ProductDetailTagsWrapper>
  )
}

const ProductDetailTagsWrapper = styled.div`
  .product-detail-tags {
    &__list {
      margin: 0;
      margin-top: 1.2rem;
      display: flex;
      flex-direction: row;
      gap: 0.8rem;
      flex-wrap: wrap;
    }
    &__tag {
      cursor: pointer;
      flex-shrink: 0;
      display: inline-block;
      border: none;
      padding: 0.6rem 1.2rem;
      border-radius: 4rem;
      background-color: ${({
        theme: {
          color: { blue30 },
        },
      }) => blue30};
    }
  }
`
